import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setPSLOptions } from '../common/CommonActions';
import { getSpotQuotePSLEffect } from '../common/CommonEffects';

const usePSLList = () => {
  const { PSLOptions } = useSelector((state) => state.common);

  const dispatch = useDispatch();

  const list = useMemo(() => {
    if (PSLOptions?.success) {
      return PSLOptions?.data || [];
    }
    return undefined;
  }, [PSLOptions]);

  useEffect(() => {
    if (!PSLOptions?.success) {
      const fetchList = async () => {
        try {
          const { data } = await getSpotQuotePSLEffect();

          const options = data.map((value) => ({
            label: value?.displayValue,
            value: value?.lookupCodeId,
          }));

          dispatch(setPSLOptions({ success: true, data: options }));
        } catch {
          dispatch(setPSLOptions({ success: false, data: [] }));
        }
      };
      fetchList();
    }
  }, [PSLOptions, dispatch]);

  return list || [];
};

export default usePSLList;
